"use strict";

exports.__esModule = true;
exports.Hook = void 0;

class Hook {
  constructor() {
    this.listeners = [];
  }

  tap(fn) {
    this.listeners.push(fn);
  }

  call(...args) {
    for (const fn of this.listeners) {
      fn(...args);
    }
  }

}

exports.Hook = Hook;